import { dataRedo } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRedo = /*#__PURE__*/createIcon(dataRedo)
export default IconRedo
